import '../App.css';
import './CampaignStatus.css';

function CampaignStatus({ status }) {
    return (
        <div>
            {
                status == 'active' &&
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'green',
                        fontWeight: 'bold',
                    }}
                >
                    <i
                        className="pi pi-check-circle"
                    />
                    <div style={{ marginLeft: '0.2em' }}>
                        active
                    </div>
                </div>
            }
            {
                status != 'active' &&
                <div className='campaign-status-inactive'>
                    <i
                        className="pi pi-times-circle"
                    />
                    <div style={{ marginLeft: '0.2em' }}>
                        inactive
                    </div>
                </div>
            }
        </div>
    );
}

export default CampaignStatus;